export default function LockedView({ phase, goHome }) {
  return (
    <div className="view" data-testid="locked-view">
      <div className="crumb">
        <a onClick={goHome} data-testid="back-to-phases">← All phases</a>
        {" / "}
        Phase {phase.id}
      </div>
      <div className="ctx-block">
        <h3>Phase {phase.id} — {phase.name}</h3>
        <p>{phase.goal}</p>
        <p
          style={{
            color: "var(--text-faint)",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 12,
            marginTop: 14,
          }}
        >
          This phase has not started. It unlocks once the prior phase completes.
        </p>
      </div>
    </div>
  );
}
